/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingUsageAggregationTrendResult extends models.BillingAggregationTrendResult {
    getFixupPrototypeFunction() { return BillingUsageAggregationTrendResult.fixupPrototype; }

    static newInstance(model: Partial<BillingUsageAggregationTrendResult>): BillingUsageAggregationTrendResult {
        let obj = Object.assign(new BillingUsageAggregationTrendResult(), model);
        BillingUsageAggregationTrendResult.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingUsageAggregationTrendResult>): BillingUsageAggregationTrendResult {
        if (!model) return null;
        return BillingUsageAggregationTrendResult.newInstance(<BillingUsageAggregationTrendResult> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingUsageAggregationTrendResult) {
        if (!obj) return;

        models.BillingUsageAggregationTrendResult.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingUsageAggregationTrendResult): boolean {
        if (models.BillingAggregationTrendResult.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingUsageAggregationTrendResult.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
